module.exports = __webpack_public_path__ + "media/react/assets/editIcon-e13cd1d8f4d7a0368414fcde03a67293.svg";